import { useEffect, useState } from 'react';
import { PaginationModels } from './models'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

function classNames(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

const Pagination = ({meta, onPageChange} : {meta : PaginationModels.MetaData, onPageChange : (page:number) => void}) => {
  const [pages, setPages] = useState<(number | "...")[]>([]);
  const startRange = ((meta.page - 1) * meta.limit) + 1;
  const endRange = meta.totalRecords > meta.limit ? (meta.page * meta.limit) : meta.totalRecords;
  
  const GeneratePages = (currentPage :  number, totalPages : number) => {
      let pages: (number | "...")[] = [];
      
      if(totalPages <= 7)
      {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
      }
      else
      {
        pages.push(1);

        if (currentPage > 3) pages.push("...");

        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);

        for (let i = start; i <= end; i++) pages.push(i);

        if (currentPage < totalPages - 2) pages.push("...");

        pages.push(totalPages)
      }

      setPages(pages);
  }
  
  useEffect(() => {
    GeneratePages(meta.page, meta.totalPages);
  }, [meta]);

  const handleNextPage = () =>
  {
    onPageChange(meta.page + 1)
  }

  const handlePreviousPage = () => 
  {
    onPageChange(meta.page - 1)
  }

  const handlePageChange = (page : number) : void => 
  {
      if (page == meta.page) return;
      onPageChange(page);
  }

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex flex-1 justify-between sm:hidden">
        <a
          href="#"
          onClick={() => onPageChange(meta.page - 1)}
          className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          href="#"
          onClick={() => onPageChange(meta.page + 1)}
          className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Next
        </a>
      </div>
            
      {  meta.totalPages > 1 &&
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium"> {startRange} </span> to <span className="font-medium"> {endRange} </span> of{' '}
            <span className="font-medium">{meta.totalRecords}</span> results
          </p>
        </div>
        
        <div>
          <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            { (meta.page > 1) &&
              <a
                onClick={handlePreviousPage}
                href="#"
                className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              >
                <span className="sr-only">Previous</span>
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
              </a>
            }

            {
              pages.map((value, index) => 
                (value != '...') ? (
                <a key={index} 
                  onClick={() => handlePageChange(value)}
                  // className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  className={classNames(
                    'relative inline-flex items-center px-4 py-2 text-sm font-medium',
                    meta.page != value ? 
                    'text-gray-600 hover:bg-gray-50 focus:outline-offset-0' : 
                    'z-10 bg-indigo-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                  )}
                >
                  {value}
                </a>
              ) : (
                <span className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 focus:outline-offset-0">
                ...
                </span>
              ))          
            }

            { (meta.page < meta.totalPages) && 
              <a
                href="#"
                onClick={handleNextPage}
                className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400  hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              >
                <span className="sr-only">Next</span>
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
              </a>
            }
          </nav>
        </div>
      </div>
      }
    </div>
  )
}

export default Pagination;